export const pageSize = 25

export default {
  pageSize
}
